import { NeoModel, ModelBase, List } from '@singularsystems/neo-core';
import TransactionDetailLookup from './TransactionDetailLookup';
@NeoModel
export default class TransactionLookup extends ModelBase {
    public eventDate: string | null = null;

    public clientNumber: string = "";

    public stockbrokerAccount: string = "";

    public eventName: string = "";

    public eventID: string = "";

    public relatedEventID: string = "";

    public instrumentDescription: string = "";

    public ticker: string = "";

    public isin: string = "";

    public currency: string = "";

    public amount: number | null = null;

    public amountUSD: number | null = null;

    public quantity: number | null = null;

    public isExcludedInd: boolean = false;

    public transactionDetail = new List(TransactionDetailLookup);

    public weightedAverageCostID : number | null = null;

    public isExpanded: boolean | null = null;
}